import { Link } from "react-router-dom";

const COLORS = {
  red: { bg: "#EAF1F8", accent: "#3E6FA8" },
  blue: { bg: "#EDEFF2", accent: "#33558A" },
  yellow: { bg: "#EEF0F4", accent: "#5C7FB0" },
};

export const ServiceCard = ({ service }) => {
  const Icon = service.icon;
  const c = COLORS[service.color] || COLORS.red;
  return (
    <div
      data-testid={`service-card-${service.id}`}
      className={`group brutal-border brutal-shadow-sm brutal-press bg-white h-full flex flex-col p-7 sm:p-8 ${
        service.featured ? "md:col-span-2" : ""
      }`}
    >
      <div
        className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6"
        style={{ backgroundColor: c.bg, color: c.accent }}
      >
        <Icon size={26} strokeWidth={2} />
      </div>
      <h3 className="font-display text-2xl sm:text-3xl leading-tight text-[#1F2530]">
        {service.title}
      </h3>
      <p className="mt-3 leading-relaxed text-[#6B7280] flex-1">{service.blurb}</p>
      <Link
        to="/contact"
        data-testid={`service-order-${service.id}`}
        state={{ service: service.title }}
        className="mt-6 inline-flex items-center gap-1.5 self-start font-semibold text-sm group-hover:gap-3 transition-all"
        style={{ color: c.accent }}
      >
        Order this →
      </Link>
    </div>
  );
};
